import type {SeriesPatternStateEnum} from './SeriesPatternStateEnum';

export type SeriesPattern = {
  prefix: string;
  startingNumber: number;
  length: number;
  from: string | null;
  to: string | null;
  state: SeriesPatternStateEnum;
};
